export default __webpack_public_path__ + "static/media/Background_00239.d77e3d42.png";